import isDesktopApp from '@/desktop-app/isDesktopApp'
import desktopApp from '@/desktop-app/desktopApp'
import ipcCommandsEnum from '@/desktop-app/ipcCommandsEnum'

/**
 * Turns the desktop app's own Bugsnag reporting (its errors, crashes and bundled pages) on or off,
 * following APP_LOGGING.ENABLED && APP_LOGGING.BUGSNAG.DESKTOP. The desktop app keeps the last value
 * for its next start, and reports until it has received one. The legacy Electron shell ignores it.
 */
const syncBugsnagReporting = (appLogging) => {
  if (!isDesktopApp() || !appLogging) return

  desktopApp().send(ipcCommandsEnum.BugsnagReporting, Boolean(appLogging.ENABLED && appLogging.BUGSNAG?.DESKTOP))
}

/**
 * Gives the desktop app the logged-in user for its own Bugsnag events: the same id, name and email
 * the POS sets in its Bugsnag (setBugSnagUser). Pass null at logout.
 */
export const syncBugsnagUser = (posUser) => {
  if (!isDesktopApp()) return

  const siteUrl = window.appConfig?.LOCATION_DATA?.SiteUrl
  const user = posUser && siteUrl
    ? {
      id   : `${posUser.staff_id}@${String(siteUrl).replace('https://', '').replace('/', '')}`,
      name : posUser.staff_name,
      email: posUser.staff_email
    }
    : null
  desktopApp().send(ipcCommandsEnum.BugsnagUser, user)
}

export default syncBugsnagReporting
